import { Box } from "@mui/system";
import React from "react";
import DataTable from "../dataTable/DataTable";
import styles from "./subTable.module.scss";
import Button from "../../components/buttons/Buttons";
import PropTypes from "prop-types";

const SubTable = (props) => {
  const { tableHeader, tableColumnData, title, handleBtnAction } = props;

  return (
    <Box className={styles.subTableWrapper} data-testid="SubTable">
      <Box className={styles.tableTitle}>{title}</Box>
      <DataTable
        columns={tableHeader}
        rows={tableColumnData}
        isShowMessage={true}
        isShowTableWhenNoResult={true}
        disableColumnMenu={true}
        disableColumnFilter={true}
        hideFooter={true}
        isCheckboxSelection={false}
        disableRowSelectionOnClick={true}
      />
      <Box className={styles.actionWrapper}>
        {tableColumnData?.length > 0 ? (
          <Button
            title="View all"
            iconStyle={styles.downloadIcon}
            buttonType="muibtn-secondary"
            withIcon={true}
            handleClick={handleBtnAction}
          />
        ) : null}
      </Box>
    </Box>
  );
};

export default SubTable;
SubTable.propTypes ={
  tableHeader:PropTypes.any, 
  tableColumnData:PropTypes.any, 
  title:PropTypes.any, 
  handleBtnAction:PropTypes.any
}
